import { Box, Typography } from "@mui/material";

const ErrorState: React.FC<{ message: string }> = ({ message }) => (
  <Box display="flex" justifyContent="center" alignItems="center" height="200px">
    <Typography color="error">{message}</Typography>
  </Box>
);

export default ErrorState;
